export default "__VITE_ASSET__3PP82QN2__"